import { createRouter, createWebHistory } from 'vue-router'
//import NotFoundView from '../components/NotFoundView.vue'
import SigninView from '../components/SigninView.vue'
import ObjectLogSection from '@/components/ObjectLogSection.vue'
import StationsListView from '../components/StationsListView/StationsListView.vue'
import MapView from '@/components/MapView/MapView.vue'
import RelationGraphView from '@/components/RelationGraphView/RelationGraphView.vue'
import StationView from '../components/StationView/StationView.vue'
import StationsPassportHistory from '@/components/StationsListView/StationsPassportHistory.vue'
import StationControlSection from '../components/StationView/StationControlSection.vue'
import StationAlertsSection from '../components/StationView/StationAlertsSection.vue'
import StationElectricMeterControlSection from '@/components/StationView/StationElectricMeterControlSection.vue'
import StationBreakerSection from '@/components/StationView/StationBreakerSection.vue'
import StationProtectionSection from '@/components/StationView/StationProtectionSection.vue'
import StationManageSection from '../components/StationView/StationManageSection.vue'
import StationViewReportSection from '../components/StationView/StationViewReportSection.vue'
import StationSecuritySection from '../components/StationView/StationSecuritySection.vue'
import StationLightningsSection from '@/components/StationView/StationLightningsSection.vue'
import StationDownloadReportSection from '../components/StationView/StationDownloadReportSection.vue'
import StationAnalyticSection from '../components/StationView/StationAnalyticSection.vue'
import StationSettingsSection from '../components/StationView/StationSettingsSection.vue'
import StationCalibrationSection from '../components/StationView/StationCalibrationSection.vue'
import StationPassportSection from '../components/StationView/StationPassportSection.vue'
import StationPassportHistory from '@/components/StationView/StationPassportHistory.vue'
import StationPassportTable from '@/components/StationView/StationPassportTable.vue'
import PostsTableView from '@/components/PostsTableView/PostsTableView.vue'
import PostView from '../components/PostView/PostView.vue'
import PostsPassportHistory from '@/components/PostsTableView/PostsPassportHistory.vue'
import PostControlSection from '../components/PostView/PostControlSection.vue'
import PostViewReportSection from '@/components/PostView/PostViewReportSection.vue'
import PostPassportSection from '@/components/PostView/PostPassportSection.vue'
import PostSettingsSection from '@/components/PostView/PostSettingsSection.vue'
import PostPassportHistory from '@/components/PostView/PostPassportHistory.vue'
import PostPassportTable from '@/components/PostView/PostPassportTable.vue'
import OrganizationsTableView from '../components/OrganizationsTableView/OrganizationsTableView.vue'
import OrganizationView from '@/components/OrganizationsTableView/OrganizationView.vue'
import UsersTableView from '../components/UsersTableView/UsersTableView.vue'
import UserView from '@/components/UsersTableView/UserView.vue'
import UserSessionsView from '@/components/UsersTableView/UserSessionsView.vue'
import AlertsView from '@/components/AlertsView/AlertsView.vue'
import AllEventsSection from '@/components/AlertsView/AllEventsSection.vue'
import AllAlertsSection from '@/components/AlertsView/AllAlertsSection.vue'
import StationSubscriptionsSection from '@/components/AlertsView/StationSubscriptionsSection.vue'
import PostSubscriptionsSection from '@/components/AlertsView/PostSubscriptionsSection.vue'
import ReportsView from '@/components/ReportsView/ReportsView.vue'
import StationChart from '@/components/StationView/StationChart.vue'


// https://vue-router-ru.netlify.app/guide/essentials/history-mode.html#html5-mode
const router = createRouter({
  history:  createWebHistory(),
  routes: [
	{
		path: '/',
		name: 'home',
		//component: StationsListView,
		redirect: { name: 'stations' },
	},
	{
		path: '/signin',
		name: 'signin',
		component: SigninView,
	},
	{
		path: '/stations',
		name: 'stations',
		component: StationsListView,
	},
	{
		path: '/stations_passport_history',
		name: 'stations_passport_history',
		component: StationsPassportHistory,
	},
	{
		path: '/station/:id',
		name: 'station',
		component: StationView,
		children: [
			// Default path
			{
				path: '',
				redirect: { name: 'station_control' }
			},
			{
				path: 'control',
				name: 'station_control',
				component: StationControlSection,
			},
			{
				path: 'alerts',
				name: 'station_alerts',
				component: StationAlertsSection,
			},
			{
				path: 'electric_meter',
				name: 'electric_meter_control',
				component: StationElectricMeterControlSection,
			},
			{
				path: 'breaker',
				name: 'station_breaker',
				component: StationBreakerSection,
			},
			{
				path: 'protection',
				name: 'station_protection',
				component: StationProtectionSection,
			},
			{
				path: 'manage',
				name: 'station_manage',
				component: StationManageSection,
			},
			{
				path: 'view_report',
				name: 'station_view_report',
				component: StationViewReportSection,
			},
			{
				path: 'security',
				name: 'station_security',
				component: StationSecuritySection,
			},
			{
				path: 'lightnings',
				name: 'station_lightnings',
				component: StationLightningsSection,
			},
			{
				path: 'download_report',
				name: 'station_download_report',
				component: StationDownloadReportSection,
			},
			{
				path: 'analytic',
				name: 'station_analytic',
				component: StationAnalyticSection,
			},
			{
				path: 'log',
				name: 'station_log',
				component: ObjectLogSection,
			},
			{
				path: 'settings',
				name: 'station_settings',
				component: StationSettingsSection,
			},
			{
				path: 'calibration',
				name: 'station_calibration',
				component: StationCalibrationSection,
			},
			{
				path: 'passport',
				name: 'station_passport',
				component: StationPassportSection,
			},
			{
				path: 'chart',
				name: 'station_chart',
				component: StationChart,
			},
			{
				path: 'history',
				name: 'station_passport_history',
				component: StationPassportHistory,
			},
			{
				path: 'passport_table',
				name: 'station_passport_table',
				component: StationPassportTable,
			},
		],
	},
	{
		path: '/posts',
		name: 'posts',
		component: PostsTableView,
	},
	{
		path: '/posts_passport_history',
		name: 'posts_passport_history',
		component: PostsPassportHistory,
	},
	{
		path: '/post/:id',
		name: 'post',
		component: PostView,
		children: [
			// Default path
			{
				path: '',
				redirect: { name: 'post_control' }
			},
			{
				path: 'control',
				name: 'post_control',
				component: PostControlSection,
			},
			{
				path: 'view_report',
				name: 'post_view_report',
				component: PostViewReportSection,
			},
			{
				path: 'log',
				name: 'post_log',
				component: ObjectLogSection,
			},
			{
				path: 'settings',
				name: 'post_settings',
				component: PostSettingsSection,
			},
			{
				path: 'passport',
				name: 'post_passport',
				component: PostPassportSection,
			},
			{
				path: 'history',
				name: 'post_passport_history',
				component: PostPassportHistory,
			},
			{
				path: 'passport_table',
				name: 'post_passport_table',
				component: PostPassportTable,
			},
			
		],
	},
	{
		path: '/map',
		name: 'map',
		component: MapView,
	},
	{
		path: '/relation-graph',
		name: 'relation_graph',
		component: RelationGraphView,
	},
	// {
	// 	path: '/alerts',
	// 	name: 'alerts',
	// 	component: AlertsView,
	// },
	{
		path: '/all_alerts',
		name: 'alerts',
		component: AlertsView,
		children: [
			// Default path
			{
				path: '',
				redirect: { name: 'alerts_table' }
			},
			{
				path: 'events',
				name: 'events_table',
				component: AllEventsSection,
			},
			{
				path: 'table',
				name: 'alerts_table',
				component: AllAlertsSection,
			},
			{
				path: 'station_subscriptions',
				name: 'station_subscriptions',
				component: StationSubscriptionsSection,
			},
			{
				path: 'post_subscriptions',
				name: 'post_subscriptions',
				component: PostSubscriptionsSection,
			},
		]
	},
	{
		path: '/reports',
		name: 'reports',
		component: ReportsView,
	},
	{
		path: '/users',
		name: 'users',
		component: UsersTableView,
	},
	{
		path: '/user/:id',
		name: 'user',
		component: UserView,
	},
	{
		path: '/user_sessions/:id',
		name: 'user_sessions',
		component: UserSessionsView,
	},
	{
		path: '/organizations',
		name: 'organizations',
		component: OrganizationsTableView,
	},
	{
		path: '/organization/:id',
		name: 'organization',
		component: OrganizationView,
	},
    // {
    //   path: '/about',
    //   name: 'about',
    //   // route level code-splitting
    //   // this generates a separate chunk (About.[hash].js) for this route
    //   // which is lazy-loaded when the route is visited.
    //   component: () => import('../views/AboutView.vue')
    // }
  ]
})

export default router
